import { render, staticRenderFns } from "./s-img.vue?vue&type=template&id=592b7757"
import script from "./s-img.vue?vue&type=script&lang=js"
export * from "./s-img.vue?vue&type=script&lang=js"
import style0 from "./s-img.vue?vue&type=style&index=0&id=592b7757&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports